module.exports = __webpack_public_path__ + "static/img/monkey_success.1660252.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/monkey_success.png
// module id = WL60
// module chunks = 1